import React from "react";
import { ServiceAgreementTemplateDto } from "../../../../types/types";
import ServiceAgreementTemplatesEditor from "../ServiceAgreementTemplatesEditor";
export function ServiceAgreementsStep({
  value,
  loading,
  onChange,
}: {
  value: ServiceAgreementTemplateDto[];
  loading: boolean;
  onChange: (value: ServiceAgreementTemplateDto[]) => void;
}) {
  return (
    <div className="card">
      {loading ? (
        <div className="field-hint">Loading agreements and consents...</div>
      ) : (
        <ServiceAgreementTemplatesEditor value={value} onChange={onChange} />
      )}
    </div>
  );
}
